export default "__VITE_PUBLIC_ASSET__94ba549d__"